module.exports = __webpack_public_path__ + "img/logout.37353538.svg";